var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLobby2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lobby",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.6 100.6",
    style: {
      enableBackground: "new 0 0 100.6 100.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    className: "st0",
    d: "M44,70c-0.9,0.9-0.9,2.5,0,3.4s2.5,0.9,3.4,0s0.9-2.5,0-3.4c-0.5-0.5-1.1-0.7-1.7-0.7 C45,69.3,44.4,69.5,44,70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    className: "st0",
    d: "M87.7,78.4c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4 c0-0.6-0.3-1.3-0.7-1.7C88.9,78.7,88.3,78.4,87.7,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    className: "st0",
    d: "M98.7,52.2H90V35.7c0-4.6-3.2-8.6-7.7-9.6l-6.4-1.4c2.3-2,3.6-4.8,3.6-7.8v-6.7 c0-5.7-4.6-10.3-10.3-10.3c-5.7,0-10.3,4.6-10.3,10.3v6.7c0,3,1.3,5.9,3.6,7.8l-6.4,1.4c-4.5,1-7.7,5-7.7,9.6v8.6H37.8 c-1.1,0-2,0.9-2,2v5.9H22v-5.5h8.2c1.1,0,2-0.9,2-2l0,0V23.5c0-1.1-0.9-2-2-2H1.9c-1.1,0-2,0.9-2,2l0,0v21.2c0,1.1,0.9,2,2,2l0,0 h8.2v5.5H1.9c-1.1,0-2,0.9-2,2l0,0v9.4c0,1.1,0.9,2,2,2l0,0h6.7v33c0,1.1,0.9,2,2,2H90c1.1,0,2-0.9,2-2l0,0V89c0-1.1-0.9-1.9-2-1.9 c-1,0-1.9,0.9-1.9,1.9v7.7H12.6V73.9h25.2c1.1,0,2-0.8,2-1.9c0-1.1-0.8-2-1.9-2h-0.1H12.6v-4.3h75.5v7.7c0,1.1,0.9,1.9,2,1.9 c1,0,1.9-0.9,1.9-1.9v-7.7h6.7c1.1,0,2-0.9,2-2l0,0v-9.4C100.7,53.1,99.8,52.2,98.7,52.2L98.7,52.2L98.7,52.2z M62.8,15.6h2.7 c3.6,0,7.1-1,10.1-3V17c0,3.5-2.8,6.4-6.3,6.5c-3.5,0-6.4-2.8-6.5-6.3c0-0.1,0-0.1,0-0.2L62.8,15.6z M69.2,27.4 c0.6,0,1.2-0.1,1.8-0.2l-1.8,4.1l-1.8-4.1C68,27.2,68.6,27.4,69.2,27.4L69.2,27.4z M69.2,3.9c2.6,0,5,1.6,5.9,4 c-2.6,2.4-6,3.7-9.6,3.7h-2.7v-1.4C62.9,6.9,65.7,3.9,69.2,3.9L69.2,3.9z M52.3,35.7c0-2.8,1.9-5.1,4.6-5.7l6.8-1.5l3.7,8.3 c0.4,1,1.6,1.4,2.6,1c0.4-0.2,0.8-0.6,1-1l3.7-8.3l6.8,1.5c2.7,0.6,4.6,3,4.6,5.7v16.5H64.9v-5.9c0-1.1-0.9-2-2-2H52.3V35.7z  M39.7,48.3h21.2v3.9H39.7V48.3z M4,25.5h24.3v17.3H22c-0.4-3.2-3.3-5.6-6.5-5.2c-2.7,0.3-4.9,2.5-5.2,5.2H4V25.5z M14.2,43.4 c0-1.1,0.8-2,1.9-2s2,0.8,2,1.9v0.1v8.8h-3.9V43.4z M96.7,61.7H3.9v-5.5h92.8C96.7,56.2,96.7,61.7,96.7,61.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobby2);
export default __webpack_public_path__ + "static/media/Lobby2.2eaa9d0dd4f0d016bfb952573a998918.svg";
export { ForwardRef as ReactComponent };